import { t } from "@/i18n-js/instance";
import { Button } from "../../../uikit/Button";
import { Typography } from "../../../uikit/Typography";

export const IgnoreAccept = () => {
  const handleIgnore = async () => {
    await Promise.resolve(() => {
      // TODO: Call the API to ignore here
      console.warn("Call ignore here");
    });
  };
  const handleAccept = async () => {
    await Promise.resolve(() => {
      // TODO: Call the API to accept here
      console.warn("Call accept here");
    });
  };

  return (
    <div className="flex w-full gap-2">
      <Button
        variant="secondary"
        onClick={async () => {
          await handleIgnore();
        }}
        aria-label={t("member_directory.ignore")}
        data-testid="ignore-button"
        className="!border-primary flex !h-8 flex-1 justify-center !px-4 !font-medium"
      >
        <Typography.LabelSm color="text-primary" weight="font-medium">
          {t("member_directory.ignore")}
        </Typography.LabelSm>
      </Button>
      <Button
        variant="circle"
        onClick={async () => {
          await handleAccept();
        }}
        aria-label={t("member_directory.accept")}
        data-testid="accept-button"
        className="!border-primary flex !h-8 flex-1 justify-center !px-4 !font-medium"
      >
        <Typography.LabelSm color="text-primary" weight="font-medium">
          {t("member_directory.accept")}
        </Typography.LabelSm>
      </Button>
    </div>
  );
};
